var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "order-statistics" },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c(
          "div",
          { staticClass: "statistics-row" },
          _vm._l(_vm.newStatisticsConfig, function (item, index) {
            return _c("div", { key: index, staticClass: "statistics-item" }, [
              _c("div", { staticClass: "statistics-content" }, [
                _c("div", { staticClass: "statistics-title" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "statistics-value",
                    style: { color: item.color },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatValue(_vm.statisticsData[item.field], item)
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }